/**
 * Checks whether the passed value is a valid dom node
 *
 * @param domNode - the dom node
 */
export function isDomNode(domNode) {
    return typeof document !== "undefined" && domNode instanceof Node;
}
/**
 * Checks for an element node like `<p>` or `<div>`.
 *
 * @param domNode - the dom node
 */
export function isElementDomNode(domNode) {
    return isDomNode(domNode) && domNode.nodeType === Node.ELEMENT_NODE;
}
